import { Helmet } from 'react-helmet-async';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { ProductConfigurationContent } from '@/pageContents/productConfiguration/ProductConfigurationContent';
import { ConfigurationPanelContextProvider } from '@/pageContents/productConfiguration/ProductConfigurationBulkUpdate/ConfigurationPanelContext';
import { Permission } from '@/models/user';

const ProductConfiguration: PageWithLayout = () => {
    return (
        <ConfigurationPanelContextProvider>
            <Helmet>
                <title>Produktkonfiguration | Starjack Backoffice</title>
            </Helmet>

            <ProductConfigurationContent />
        </ConfigurationPanelContextProvider>
    );
};

ProductConfiguration.isProtected = true;
ProductConfiguration.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
ProductConfiguration.permissions = [Permission.LIFTOPERATOR_CONFIGURATION_NAV];

export default ProductConfiguration;
